import LogRocket from 'logrocket';
import { useEffect } from 'react';

import { PRODUCTION_ORIGINS } from '@/app/constant';
import { useAuth } from '@/state/auth';

export const LogRocketIdentifier = () => {
  const { isSignedIn, me, ssoDomain } = useAuth();

  useEffect(() => {
    // Only run LogRocket identify on production
    if (!PRODUCTION_ORIGINS.includes(window.location.origin)) {
      return;
    }

    if (isSignedIn && me) {
      // Extract name from email (simple approach - you can customize this)
      const name = me.split('@')[0].replace(/[._]/g, ' ');

      const identifyData: Record<string, string | number | boolean> = {
        name: name,
        email: me,
        isPraetorianUser: me.endsWith('@praetorian.com'),
      };

      if (ssoDomain) {
        identifyData.ssoDomain = ssoDomain;
      }

      LogRocket.identify(me, identifyData);
    }
  }, [isSignedIn, me, ssoDomain]);

  return null; // This component doesn't render anything
};
